import React from 'react';

/**
 * Thin progress bar with teal/beige gradient fill. Ported verbatim from
 * D:\campaigning-system\src\components\ui\ProgressBar.tsx (types stripped).
 */
export function ProgressBar({ value, className = '', showLabel = false, tone = 'teal' }) {
  const clamped = Math.max(0, Math.min(100, value));
  const fill =
    tone === 'teal'
      ? 'linear-gradient(90deg, #16B8AA, #087F78)'
      : 'linear-gradient(90deg, #DED7C8, #B7AD96)';
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-[rgba(70,80,72,0.10)]">
        <div
          className="h-full rounded-full transition-[width] duration-500"
          style={{ width: `${clamped}%`, background: fill }}
        />
      </div>
      {showLabel && <span className="mono w-9 text-right text-2xs font-semibold text-cos-ink-secondary">{Math.round(clamped)}%</span>}
    </div>
  );
}

export default ProgressBar;
